import { useCallback, useEffect, useState } from 'react';
import {
  ShopSaleType,
  TimerTimestampState,
  TimerLocKeyState,
  SaleStatus,
} from '../state/sales/sales.types';
import { getSaleStatus } from '../utils/shop.utils';

const useShopSaleTimer = (sale: ShopSaleType) => {
  const [locKey, setLocKey] = useState<TimerLocKeyState>();
  const [timestamp, setTimestamp] = useState<TimerTimestampState>();

  const updateTimer = useCallback(() => {
    const {
      fromCountdownEnabled,
      toCountdownEnabled,
      availableFrom,
      availableTo,
    } = sale;

    let newLocKey: TimerLocKeyState;
    let newTimestamp: TimerTimestampState;

    if (fromCountdownEnabled && getSaleStatus(sale) === SaleStatus.Upcoming) {
      newLocKey = 'saleBannerStartingIn';
      newTimestamp = availableFrom;
    } else if (
      toCountdownEnabled &&
      getSaleStatus(sale) === SaleStatus.Ongoing
    ) {
      newLocKey = 'saleBannerEndingIn';
      newTimestamp = availableTo;
    }

    setLocKey(newLocKey);
    setTimestamp(newTimestamp);
  }, [sale]);

  useEffect(updateTimer, []);

  return {
    timestamp,
    locKey,
    updateTimer,
  };
};

export default useShopSaleTimer;
